module.exports = __webpack_public_path__ + "img/goodcase04.b0dc0c70.png";